import { CloseIcon } from '@chakra-ui/icons';
import { Box, Heading } from '@chakra-ui/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
interface Props {
	title: string;
	closeIconPath: string;
}
const HeaderWithCloseIcon = ({ title, closeIconPath }: Props) => {
	const navigate = useNavigate();
	return (
		<Box
			h="48px"
			alignItems={'center'}
			justifyContent={'space-between'}
			boxShadow={'0px 1px 2px 0px rgba(0, 0, 0, 0.06), 0px 1px 3px 0px rgba(0, 0, 0, 0.10);'}
			display={'flex'}
			py="12px"
			px="16px"
		>
			<Heading color={'#0A0103'} mx="auto" as="h5">
				{title}
			</Heading>
			<CloseIcon
				onClick={() => {
					navigate(closeIconPath);
				}}
				color="#0A0103"
				boxSize={'12px'}
			/>
		</Box>
	);
};

export default HeaderWithCloseIcon;
